module.exports = __webpack_public_path__ + "8100fab69f6aebecd1e529b4a89777f6.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/body/hoodie-orange.png
// module id = 1867
// module chunks = 0